import { DevTool } from '@hookform/devtools';
import { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

export interface FormProps<T> {
	children?: ReactNode | null;
	defaultValues?: T;
	onSubmit: (data: T) => void;
	resetOnSubmit?: boolean;
	id?: string;
}

export const Form = <T extends object>(props: FormProps<any>) => {
	const { children, defaultValues, onSubmit, resetOnSubmit, id } = props;
	const methods = useForm<T>({
		defaultValues: defaultValues,
		criteriaMode: 'all',
		shouldFocusError: true,
		mode: 'onTouched',
		reValidateMode: 'onChange',
	});
	const { handleSubmit, control, reset } = methods;

	const onFormSubmit = (data: T) => {
		onSubmit(data);
		if (resetOnSubmit) {
			reset();
		}
	};

	return (
		<FormProvider {...methods}>
			<form style={{ width: '100%' }} onSubmit={handleSubmit(onFormSubmit)} id={id}>
				{children}
			</form>

			{typeof process !== 'undefined' && process.env?.['NODE_ENV'] === 'development' && (
				<DevTool control={control} />
			)}
		</FormProvider>
	);
};
